export const OnBoardingStatus = {
  SIGN_IN: 0,
  SIGN_UP: 1,
  ROLE_SELECT: 2,
  PROFILE: 3,
  ONBOARD_START: 2,
  ONBOARD_EXIT: 4,
};